// extracted by mini-css-extract-plugin
module.exports = {"root":"locationCarousel_root__13aXc"};